export default __webpack_public_path__ + "static/media/interview-cake.37432cbb.jpg";